<template>
	<div>
		<div
			class="p-d-flex p-flex-column p-text-center p-justify-center p-ai-center p-grid"
		>
			<div id="s1form">
				<h1 class="p-text-bold p-my-0">Membership</h1>
				<Message v-if="submitted && errorMessage != null" severity="error">
					{{ errorMessage }}
				</Message>

				<div>
					<h3 class="p-text-bold p-mt-3 p-mb-2">
						Are you a member or subsidized?
					</h3>

					<span>
						Membership has its privileges. <br />Being a member gives you 20%
						off all of our programs
					</span>
				</div>

				<div class="p-grid p-fluid p-d-flex p-jc-center p-mt-3">
					<div class="p-col-6" style="width: 150px">
						<ToggleButton
							v-model="isMember"
							onLabel="Yes"
							offLabel="Yes"
							class="p-py-2.5"
						/>
					</div>

					<div class="p-col-6" style="width: 150px">
						<ToggleButton
							v-model="isNotMember"
							onLabel="No"
							offLabel="No"
							class="p-py-2.5"
						/>
					</div>
				</div>

				<div
					v-if="isMember"
					class="p-fluid p-grid p-formgrid p-text-left p-jc-center p-mt-4"
				>
					<h3 class="p-col-12 p-text-center p-text-bold">
						Member/Subsidy Verification
					</h3>

					<div class="p-col-12 p-d-flex p-flex-column p-jc-center">
						<div class="p-field p-mb-3 p-col-12">
							<label for="email" class="p-text-bold">Email *</label>

							<InputText
								id="email"
								v-model="email"
								placeholder="Email"
								inputmode="email"
								type="text"
							/>

							<span v-if="v$.email.$invalid && submitted">
								<span
									id="email-error"
									v-for="(error, index) of v$.email.$errors"
									:key="index"
								>
									<small class="p-error p-text-bold">
										{{
											error.$message == "Value is required"
												? error.$message.replace("Value", "Email")
												: error.$message.replace(
														"Value is not a valid",
														"Invalid"
												  )
										}}
									</small>
								</span>
							</span>
						</div>
						<div class="p-field p-mb-3 p-col-12">
							<label for="lastName" class="p-text-bold">Last Name *</label>

							<InputText
								id="lastName"
								v-model="lastName"
								placeholder="Last Name"
								type="text"
							/>

							<small
								v-if="v$.lastName.$invalid && submitted"
								class="p-error p-text-bold"
							>
								{{
									v$.lastName.required.$message.replace("Value", "Last Name")
								}}
							</small>
						</div>
					</div>

					<div class="p-d-flex p-jc-center p-mt-4 p-col-12">
						<Button
							label="Next"
							icon="pi pi-angle-right"
							iconPos="right"
							style="min-width: 120px; max-width: 120px"
							@click="nextStep()"
						/>
					</div>
				</div>

				<div
					v-if="isNotMember"
					class="p-d-flex p-flex-column p-jc-center p-mt-4"
				>
					<span class="p-text-center">
						Would you like to become a member? Being a member gives you 20% off
						all our programs.
					</span>

					<div class="p-d-flex p-flex-column p-ai-center">
						<div class="p-field-radiobutton p-mt-3">
							<RadioButton
								id="singleMembership"
								name="Yes, I want a Single Membership"
								value="singleMembership"
								v-model="becomeMember"
							/>

							<label for="singleMembership" class="p-text-bold">
								Yes, I want a Single Membership <br />
								<span class="p-text-normal">($55.00 for 1 child)</span>
							</label>
						</div>

						<div class="p-field-radiobutton">
							<RadioButton
								id="familyMembership"
								name="Yes, I want a Family Membership"
								value="familyMembership"
								v-model="becomeMember"
							/>

							<label for="familyMembership" class="p-text-bold">
								Yes, I want a Family Membership <br />
								<span class="p-text-normal">
									($70.00 for 2 or more children)
								</span>
							</label>
						</div>

						<div class="p-field-radiobutton">
							<RadioButton
								id="noMembership"
								name="No, Thank You"
								value="noMembership"
								v-model="becomeMember"
							/>

							<label for="noMembership" class="p-text-bold">
								No, Thank You
							</label>
						</div>
					</div>

					<small
						v-if="v$.becomeMember.$invalid && submitted"
						class="p-error p-text-bold p-mt-0"
					>
						{{
							v$.becomeMember.required.$message.replace(
								"Value is required",
								"Selecting one is required"
							)
						}}
					</small>

					<div class="p-d-flex p-jc-center p-mt-4">
						<Button
							label="Next"
							icon="pi pi-angle-right"
							iconPos="right"
							style="min-width: 120px; max-width: 120px"
							:loading="isLoading"
							:disabled="isLoading"
							@click="nextStep()"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import axios from "axios";

export default {
	name: "Membership",
	components: {},
	data() {
		return {
			isLoading: false,
			errorMessage: null,
			isMember: false,
			isNotMember: false,
			email: null,
			lastName: null,
			submitted: false,
			becomeMember: {},
			showAddons: true,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate(),
		};
	},

	validations() {
		return {
			isMember: { required },
			lastName: this.isMember ? { required } : "",
			email: this.isMember
				? {
						required,
						email,
				  }
				: "",
			becomeMember: this.isNotMember ? { required } : "",
		};
	},
	props: {
		loadDonationParams: {
			type: Object,
		},
	},
	methods: {
		async apiCall() {
			let payload = {};

			if (this.isMember) {
				payload = {
					isMember: "Yes",
					email: this.email,
					lastName: this.lastName,
					formName: this.store.formName,
					sandbox: this.store.testMode,
				};
			} else if (this.isNotMember) {
				payload = {
					isMember: "No",
					membership:
						this.becomeMember === "singleMembership"
							? "Single"
							: this.becomeMember === "familyMembership"
							? "Family"
							: "",
					formName: this.store.formName,
					sandbox: this.store.testMode,
				};
			}

			await axios
				.post("https://api.pllenty.com/girls-inc2/membership/validate", payload)
				.then((response) => {
					this.store.membershipPayload = response.data;

					for (const location in response.data.items) {
						const weeks = response.data.items[location];
						for (const week of weeks) {
							const addons = week.addons || [];
							if (addons.length > 0) {
								this.showAddons = true;
							} else {
								this.showAddons = false;
							}
						}
					}
					this.store.membershipPayload.showAddons = this.showAddons;

					this.isLoading = false;
					this.$emit("nextStep");
				})
				.catch((error) => {
					// console.log("error", error.response);
					this.errorMessage = error.response.data.errorMessage;
					this.isLoading = false;
				});
		},
		async nextStep() {
			const isFormValid = await this.v$.$validate();
			this.submitted = true;

			if (isFormValid) {
				this.isLoading = true;
				this.store.Membership = this.isMember
					? {
							lastName: this.lastName,
							email: this.email,
							isMember: this.isMember ? "Yes" : "No",
							formName: this.store.formName,
					  }
					: {
							isMember: this.isMember ? "Yes" : "No",
							formName: this.store.formName,
							becomeMember:
								this.becomeMember === "singleMembership"
									? "Single"
									: this.becomeMember === "familyMembership"
									? "Family"
									: "",
					  };

				this.apiCall();
			} else {
				this.scrollToFirstError();

				return;
			}
		},
		scrollToFirstError() {
			this.$nextTick(() => {
				if (document.querySelector(".p-error")) {
					let domRect = document
						.querySelector(".p-error")
						.getBoundingClientRect();

					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 100,
						behavior: "smooth",
					});
				}
			});
		},
	},
	watch: {
		isMember() {
			if (this.isMember) {
				this.isNotMember = false;
				this.isLoading = false;
			}
		},
		isNotMember() {
			if (this.isNotMember) {
				this.isMember = false;
				this.isLoading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#s1form {
	max-width: 400px;
}
</style>
